import styled from "styled-components";
import { Spinner } from "styles/components";
import { Button, Select } from "styles/elements";
import { CenterFlexColumn } from "styles/layout";
import { Theme } from "theme";

export const FormContainer = styled(CenterFlexColumn)`
  padding: ${Theme.bigPanelPadding};
`;

export const FormTable = styled.table`
  th {
    font-weight: 500;
    text-align: right;
    padding-right: 5px;
  }
`;

export const Input = styled.input`
  padding: 3px;
  width: 200px;
`;

export const CreateGroupButton = styled(Button)`
  padding: 4px;
  margin-top: 25px;
  font-size: 12pt;
  width: 150px;
`;

export const CreateGroupSelect = styled(Select)`
  width: 120px;
  padding: 5px 5px 5px 1px;
`;

export const InProgressSpinner = styled(Spinner)`
  border-width: ${Theme.spinnerSmallBorderWidth};
  width: 12px;
  height: 12px;
  margin: auto;
`;
